import type { ReactElement } from 'react';

import { Carousel } from '@xing-com/carousel';
import {
  JobTeaserCardSkeleton,
  JobTeaserListItemSkeleton,
} from '@xing-com/crate-jobs-xinglets';
import { GridItem } from '@xing-com/grid';
import { NotOnSmall, OnlyOnSmall } from '@xing-com/layout-primitives';

import { getCarouselConfig } from './similar-jobs-carousel';

export const SimilarJobsLoading: React.FC<{
  count: number;
  isCarousel?: boolean;
}> = ({ count, isCarousel = false }) => {
  // Carousel skeleton needs to be in just 1 GridItem, otherwise it breaks the layout
  const getCarouselSkeleton = (index: number): ReactElement | null => {
    if (index === 0)
      return (
        <Carousel {...getCarouselConfig()} tabIndex={-1}>
          {Array.from({ length: count }).map((_, subIndex) => (
            <JobTeaserCardSkeleton key={subIndex} />
          ))}
        </Carousel>
      );
    return null;
  };
  return Array.from({ length: count }).map((_, index) => (
    <GridItem key={index} span={12} spanLarge={4}>
      <OnlyOnSmall>
        {isCarousel ? (
          getCarouselSkeleton(index)
        ) : (
          <JobTeaserListItemSkeleton />
        )}
      </OnlyOnSmall>
      <NotOnSmall>
        <JobTeaserCardSkeleton />
      </NotOnSmall>
    </GridItem>
  ));
};
